"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineMethods = defineMethods;
function defineMethods(extraMethods) {
    return extraMethods;
}
//# sourceMappingURL=defineMethods.js.map